import * as React from "react";
import { useCallback } from "react";
import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { patientNewVersionZIndex } from "./patientStacking";
import { PatientColorMap } from "./patientColorMap";
import { getVersion } from "../VersionInfo";
import { useSaveConversationInStorage } from "../solverHooks/saveConversation";
import { useTranslate } from "../hooks/useTranslate";
import { NewVersionPopover } from "fe-web-components/newVersionPopover"
//region [[ Styles ]]

const PatientNewVersionPopOverView = styled(NewVersionPopover)(({ theme }) => ({
  background: KahunColorMap.White,
  height: "57px",
  padding: "17px",
  zIndex: patientNewVersionZIndex,
  boxSizing: "border-box",
  "& .new-version-text": {
    color: PatientColorMap.Primary,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
    padding: "0 12px",
  },
  "& .update-button": {
    height: "32px",
    width: "85px",
    color: PatientColorMap.DefaultLight,
    background: PatientColorMap.Primary,
  },
  "& .close-button": {
    height: "23px",
    width: "23px",
    background: PatientColorMap.Primary,
    "& svg": {
      fill: PatientColorMap.DefaultLight,
    },
    "&:hover": {
      background: PatientColorMap.PrimaryLight,
      "& svg": {
        fill: PatientColorMap.DefaultLight,
      },
    },
  },
}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface PatientNewVersionPopOverProps {}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientNewVersionPopOver = ({
  ...props
}: PatientNewVersionPopOverProps) => {
  const currentVersion = getVersion();

  const saveConversationInStorage = useSaveConversationInStorage();

  const savePatientCase = useCallback(() => {
    saveConversationInStorage();
  }, [saveConversationInStorage]);

  const { translate } = useTranslate();

  return (
    <PatientNewVersionPopOverView
      version={currentVersion}
      onReloadClicked={savePatientCase}
      translate={translate}
    />
  );
};
